import { getToken } from '@/api/qiniu'

const state = {
    Token: null,
    Expire_time: 0,
    loading: false
}
const mutations = {
    SET_Token: (state, data) => {
        state.Token = data
    },
    SET_Expire_time: (state, data) => {
        state.Expire_time = data
    },
    SET_LOADING: (state, loading) => {
        state.loading = loading
    }

}
const actions = {
    getToken({ commit }) {
        return new Promise((resolve, reject) => {
            var timestamp = new Date().getTime();
            if (state.loading) {
                resolve(state.Token)
            } else if (state.Token == null || state.Expire_time < timestamp) {
                commit('SET_LOADING', true);
                getToken().then(response => {
                    commit('SET_Token', response.data);
                    commit('SET_Expire_time', timestamp + 100 * 1000); // 100 秒刷新
                    commit('SET_LOADING', false);
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                    commit('SET_LOADING', false);
                })
            } else {
                resolve(state.Token)
            }
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}